module.exports = __webpack_public_path__ + "img/logo.ba731c17.svg";